import { render, staticRenderFns } from "./productIntro.vue?vue&type=template&id=5c627e3e&"
import script from "./productIntro.vue?vue&type=script&lang=js&"
export * from "./productIntro.vue?vue&type=script&lang=js&"
import style0 from "./productIntro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports